import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';

const TextContainer = styled.div`
  overflow: hidden;
  margin-bottom: 12px;
  transition: all 0.3s ease-in-out;
  -webkit-line-clamp: 2;

  .deactive-user-label {
    color: ${color.black} !important;
    font-family: var(--font-bold);
  }

  // styling for masking text
  .insider-indicator.green {
    color: ${color.primary};
    background: transparent;
  }
  .insider-indicator.red {
    color: ${color.sunsetOrange};
    background: transparent;
  }

  // styling for masking text at safari
  @supports (font: -apple-system-body) and (-webkit-appearance: none) {
    p {
      line-height: 1.6;
    }
  }
`;

const FormatedText = styled(Text)`
  mark {
    background-color: #ff0;
    padding: 0px;
    color: ${color.dark};
  }

  a > span > mark {
    color: unset;
  }
`;

export { TextContainer, FormatedText };
